export default {"src":"/_next/static/media/Rectangle 453.7d6a0dff.svg","height":1831,"width":1369,"blurWidth":0,"blurHeight":0};